module.exports = __webpack_public_path__ + "img/guarantee_03one@2x.d1152195.png";